// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlJXvrw7xkLjj9ZfJnPe7N4Okh390Uob4",
  authDomain: "react-pwa-d8b67.firebaseapp.com",
  projectId: "react-pwa-d8b67",
  storageBucket: "react-pwa-d8b67.firebasestorage.app",
  messagingSenderId: "175839362572",
  appId: "1:175839362572:web:c37e18b1389c3b252e3829",
  measurementId: "G-L2HWMXRX9E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { messaging };